import { CustomerChart } from "components/charts";
import { ChartLayout } from "layouts";
import { CustomerData } from "content/Chart";
import { useState, useEffect } from "react";
import { Spinner } from "components";

function Customer({
  customersData = { categories: [], data: [], loading: false, error: null },
  setDateRange,
}) {
  const { colors } = CustomerData || {
    colors: ["#19a8a6", "#fab54e", "#1467b0", "#19a8a6"],
  };
  const { categories = [], data = [], loading, error } = customersData;
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    if (loading) {
      setFadeIn(false);
    } else {
      const timer = setTimeout(() => {
        setFadeIn(true);
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [loading]);

  return (
    <ChartLayout title="Customer" isDateFilter={true} setDate={setDateRange}>
      {loading ? (
        <div className="flex flex-col items-center justify-center h-full p-4 min-h-96 transition-opacity duration-300 ease-in-out">
          <div className="animate-pulse">
            <Spinner size="large" color="#19a8a6" />
          </div>
        </div>
      ) : error ? (
        <div className="flex items-center justify-center h-full transition-opacity duration-300 ease-in-out">
          <div className="text-red-500">Error loading customer data</div>
        </div>
      ) : (
        <div
          className={`transition-opacity duration-300 ease-in-out ${
            fadeIn ? "opacity-100" : "opacity-0"
          }`}
        >
          <div className="max-w-96 mx-auto">
            <CustomerChart
              colors={colors}
              labels={categories}
              series={data}
              key={`customer-chart-${JSON.stringify(
                categories
              )}-${JSON.stringify(data)}`}
            />
          </div>
        </div>
      )}
    </ChartLayout>
  );
}
export default Customer;
